import React, { useRef, useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import stemIcon from '../images/stemIcon.jpg';
import securityClearanceIcon from '../images/securityClearanceIcon.jpg';
import veteranIcon from '../images/dogtag.png';
import socialImage from '../images/DSC08680.jpg';
import caciCaresMap from '../images/CACI_Cares_US_Map_Stars.jpg';
import philanthropyImage from '../images/caci-cares.jpg';
import alabamaSchoolLogo from '../images/LARGE-ASCTE-LOGO---H.RES.png';
import meritScholarshipLogo from '../images/National-Merit-Scholarship-Corporation-Logo-Black.png';
import firstLogo from '../images/FIRST_Logo.png';
import navyStemLogo from '../images/Navy_League_STEMEXPO-2022.png';
import nvscLogo from '../images/NVCC_Logo.png';
import causeLogo from '../images/BSF_Logo_Classic_CMYK-600x230.png';
import spookstockLogo from '../images/9365850-logo.png';
import tapsLogo from '../images/TAPSlogo.png';
import fisherHouseLogo from '../images/fisher-house-logo.png';
import omkLogo from '../images/omkLogo.png';
import wreathsAcrossAmericaLogo from '../images/WAA-Logo-with-Transparency-300x236.png';
import scoutingAmericaLogo from '../images/ScoutingAmerica_Logo.png';
import gmuLogo from '../images/gmuIcon.png';
import employeeWellBeingImage from '../images/June2023CACI_37.jpg';
import honorFoundationLogo from '../images/THF_Logo_stacked_navy.png';
import trainingImage from '../images/DSC08709_Revised.jpg';
import careerMobilityImage from '../images/CACI 2018-412.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import CounterAnimation from '../components/CounterAnimation';
import CustomCircularProgress from '../components/CustomCircularProgress';
import './Pages.css';

export default function Social()
{
	localStorage.setItem('activeLinkIndex', '6');

	const [activeSection, setActiveSection] = useState('section1');
  const [userClicked, setUserClicked] = useState(false);
  const navigate = useNavigate();
  const leftArrowRef = useRef(null);
  const rightArrowRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!userClicked) {
        const sections = document.querySelectorAll('.section');
        sections.forEach((section) => {
          const rect = section.getBoundingClientRect();
          const isNearTop = rect.top <= 120 && rect.bottom >= 0;
          if (isNearTop) {
            setActiveSection(section.id);
          }
        });
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [userClicked]);

  const scrollToSection = (sectionId, offset) => 
  {
    const section = document.getElementById(sectionId);
    setUserClicked(true); // Set the flag when a user clicks a menu item
    const offsetTop = section.offsetTop - offset;
	window.scrollTo({ top: offsetTop, behavior: 'smooth' });
    setTimeout(() => {
      setUserClicked(false); // Reset the flag after a delay
    }, 1000); // Adjust the delay as needed
  };

	return (
		<>
		<Container fluid>
			<div className='subMenu'>
				<ul>
					<li 
						onClick={() => { scrollToSection('section1', 90);
										for (let i = 0; i <= 4; i++)
										{
											document.getElementsByClassName('subMenuItem')[i].classList.remove('active');
										}
										document.getElementsByClassName('subMenuItem')[0].classList.add('active');
				}}>
						<span className={`subMenuItem ${activeSection === 'section1' ? 'active' : ''}`}>Our people</span>
					</li>
					<li 
						onClick={() =>{ scrollToSection('section2', 90); 	    
										for (let i = 0; i <= 4; i++)
										{
											document.getElementsByClassName('subMenuItem')[i].classList.remove('active');
										}
										document.getElementsByClassName('subMenuItem')[1].classList.add('active');
				}}><span className={`subMenuItem ${activeSection === 'section2' ? 'active' : ''}`}>Philanthropy</span></li>
				<li 
						onClick={() =>{ scrollToSection('section3', 90); 	    
										for (let i = 0; i <= 4; i++)
										{
											document.getElementsByClassName('subMenuItem')[i].classList.remove('active');
										}
										document.getElementsByClassName('subMenuItem')[2].classList.add('active');
				}}><span className={`subMenuItem ${activeSection === 'section3' ? 'active' : ''}`}>Employee well-being</span></li>
				<li 
						onClick={() =>{ scrollToSection('section4', 90); 	    
										for (let i = 0; i <= 4; i++)
										{
											document.getElementsByClassName('subMenuItem')[i].classList.remove('active');
										}
										document.getElementsByClassName('subMenuItem')[3].classList.add('active');
				}}><span className={`subMenuItem ${activeSection === 'section4' ? 'active' : ''}`}>Workplace safety</span></li>
				<li 
						onClick={() =>{ scrollToSection('section5', 90); 	    
										for (let i = 0; i <= 4; i++)
										{
											document.getElementsByClassName('subMenuItem')[i].classList.remove('active');
										}
										document.getElementsByClassName('subMenuItem')[4].classList.add('active');
				}}><span className={`subMenuItem ${activeSection === 'section5' ? 'active' : ''}`}>Employee training & development</span></li>
				</ul>
			</div>
			<div className='contentArea sub'>
				<Row className='headerRow gx-5'>
					<h1 data-aos='fade-left' data-aos-duration='750' data-aos-once='true'>Social</h1>
				</Row>
				<hr/>
				<Row className='gx-5 section' id='section1'>
					<Col lg={6}>
						<p className='callOutParagraph' data-aos='zoom-in' data-aos-duration='750' data-aos-once='true'>Our people are our greatest asset.</p>
						<p>We take pride in cultivating an accessible, approachable culture where every team member feels supported and valued.</p>
						<p>As a partner to some of our nation’s most critical government agencies, CACI offers employees boundless opportunities to grow, develop, and pursue limitless potential.</p>
						<p>We believe character and innovation go hand-in-hand, and we are committed to ethics and integrity in everything we do.</p>
						<br/>
						<Row className='gx-5 employeeDemographicsRow'>
							<Col xs={4}>
								<img alt='an icon of a graduation hat.' src={stemIcon} style={{width: '50%'}} />
								<br/>
								<br/>
								<div data-aos='fade-up' data-aos-duration='750' data-aos-once='true'>
								<span className="infographicHeading"><CounterAnimation targetNumber={39.4} />%</span>
					      <br/>
					      <span className='infographicSubHeading'>STEM degrees</span>
					      </div>
							</Col>
							<Col xs={4}>
								<img alt='an icon of a badge with a lock on it.' src={securityClearanceIcon} style={{width: '50%'}} />
								<br/>
								<br/>
								<div data-aos='fade-up' data-aos-duration='750' data-aos-once='true'>
								<span className="infographicHeading"><CounterAnimation targetNumber={79.4} />%</span>
					      <br/>
					      <span className='infographicSubHeading'>Security<br/> clearances</span>
					      </div>
							</Col>
							<Col xs={4}>
								<img alt='an icon of a military personnel.' src={veteranIcon} style={{width: '50%'}} />
								<br/>
								<br/>
								<div data-aos='fade-up' data-aos-duration='750' data-aos-once='true'>
								<span className="infographicHeading"><CounterAnimation targetNumber={37.5} />%</span>
					      <br/>
					      <span className='infographicSubHeading'>Veterans</span>
					      </div>
							</Col>
						</Row>
					</Col>
					<Col lg={6} className='mt-3 mt-lg-0'>
						<img alt='Office workers in a meeting.' data-aos='fade-left' data-aos-duration='750' data-aos-once='true' src={socialImage} style={{width: '100%'}} />
					</Col>
				</Row>
				<br/>
				<Row className='gx-5 mt-5'>
					<Col lg={6}>
								<span style={{fontSize: '2rem', fontWeight: '600'}}>Character</span>
								<p className='callOutParagraph' style={{fontWeight: '300'}}>Our commitment to ethics and integrity.</p>
							</Col>
							<Col lg={6}>
								<span style={{fontSize: '2rem', fontWeight: '600'}}>Innovation</span>
								<p className='callOutParagraph' style={{fontWeight: '300'}}>Our dedication to advancementand excellence.</p>
						</Col>
				</Row>
				<Row className='gx-5 mt-5'>
					<Col lg={6}>
						<h3 className='mt-5 mb-4'>Ethical engagement</h3>
						<p>We are proud to be an ethical role model in our industry, empowering our employees to succeed by fostering a workplace built on integrity and respect. This culture shapes how we conduct business and connect with each other.</p>
						<h3 className='mt-5 mb-4'>Employee feedback</h3>
						<p>We conduct an employee engagement survey every two years. The results demonstrate that we are well above our peers in sustainable engagement, flexibility, building collaborative teams, and demonstrating strong ethics and integrity. Employees overwhelmingly report being proud to be associated with CACI and confident they can achieve the goals they set for themselves. These indicators of a strong company culture help us attract and retain talent.</p>
						<p>With a 63% response rate, consistent with prior years, employees from CACI offices, customer sites, and those working remotely/hybrid were all well represented and the results were largely positive, reflecting the dedication and hard work of our entire team.</p>
						<h4 className='mt-5 mb-4'>Strengths</h4>
						<p>Feedback showed several strengths we can continue to build on:</p>
						<ul>
							<li><strong>High engagement:</strong> Nearly 90% of employees expressed a favorable sentiment about their engagement, exceeding the averages of high-performing companies and key industry benchmarks. Additionally, 86% of employees said that they are proud to be associated with CACI.</li>
							<li><strong>Ethics and integrity:</strong> CACI’s reputation for ethics and integrity remains strong, with favorability scores in this area well above industry benchmarks.</li>
						</ul>
							<p>In alignment with CACI’s Employee Value Proposition — Your potential is limitless. So is ours. — the core themes of teamwork, career advancement, and mission all continue to resonate. Approximately 93% of employees said their colleagues are supportive and their teams collaborate effectively.</p>

						<h3 className='mt-5 mb-4'>Mentoring</h3>
						<p>Mentors foster connections, engagement, learning, and growth among employees at every stage of their career. Our mentoring program provides employees with personalized coaching and assistance, feedback on their career goals, an understanding of CACI culture, increased visibility with executives, and the development of important interpersonal skills.</p>
						<h3 className='mt-5 mb-4'>Touchpoints</h3>
						<p>Touchpoints is our performance management philosophy designed to foster meaningful communication between managers and employees. Through discussions held three times per year, managers and employees discuss professional aspirations, achievements, growth, and performance. About 98% of employees who complete the post-Touchpoint survey report that their conversations with their managers are productive — a testament to how this program enhances the employee experience, and ultimately, engagement and productivity.</p>
					</Col>
				</Row>
				<br/>
				<Row className='gx-5'>
					<Col lg={6}>
						<h2 className='mt-5 mb-4 section' id='section2'>Philanthropy</h2>
						<img alt='CACI employees volunteering at Arlington National Cemetary.' src={caciCaresMap} style={{width: '50%'}} />
						<br/>
						<p>We support our nation through philanthropic programs and initiatives that help our country, our military, their families, and our future leaders. Our CACI Cares program focuses on two areas:</p>
						<span style={{fontWeight: '300', color: '#000'}}>1.</span>&nbsp;&nbsp;&nbsp;&nbsp;STEM education for the next generation of innovators.
						<br/>
						<br/>
						<span style={{fontWeight: '300', color: '#000'}}>2.</span>&nbsp;&nbsp;&nbsp;&nbsp;Support of military, veterans, and their families to honor our heroes who serve.
						<br/>
						<br/>
						<p>Through CACI Cares, we form strategic partnerships with nonprofit organizations aligned with our vision, mission, and culture.</p>
						<p>CACI also sponsors regional community philanthropic efforts in the metro areas of Huntsville, Alabama; Fayetteville, North Carolina; Washington, D.C.; and Aberdeen, Maryland.</p>
						<h3 className='mt-5 mb-4'>Volunteering</h3>
									<p>Volunteering is one of the many ways our employees embody CACI’s culture of character. Individuals within our workforce generously offer their time to important initiatives in their local communities around the world.</p>
					</Col>
					<Col lg={6} className='mt-3 mt-lg-0'>
						<img alt='a US map with the CACI Cares logo on top if it and stars over the cities of San Antonio, Huntsville, Washington, D.C., and Aberdeen.' data-aos='fade-left' data-aos-duration='750' data-aos-once='true' src={philanthropyImage} style={{width: '100%'}} />
					</Col>
				</Row>
				<br/>
				<Row className='gx-5 mt-5'>
					<Col>
							<Row>
							<Col>
							<p className='callOutParagraph' data-aos='zoom-in' data-aos-duration='750' data-aos-once='true'>CACI invests in the next generation of leaders <span style={{fontWeight: '300'}}>by supporting initiatives and organizations that encourage STEM education to develop our nation's future workforce.</span></p>
							</Col>
							</Row>
						<Row className='gx-5 mt-5'>
							<Col lg={6}>
								<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft text-center'>
										<img alt='Alabama School of Cyber Technology and Engineering logo.' src={alabamaSchoolLogo} className='socialCompanyLogo' />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>Alabama School of Cyber Technology and Engineering</h4>
									<p>The Alabama School of Cyber Technology and Engineering (ASCTE) is the nation’s only high school focused on the integration of cyber technology and engineering into all academic disciplines. ASCTE is a public, residential magnet high school serving students throughout the state of Alabama. Tuition is free.</p>
									<p>The ASCTE faculty is composed of field and subject matter experts providing students with the highest quality of instruction focused on embedding cyber protections into the engineering cycle.</p>
									</div>
								</div>
								<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft text-center'>
										<img alt='National Merit Scholarship Corporation logo.' src={meritScholarshipLogo} className='socialCompanyLogo' />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>National Merit Scholarship Corporation</h4>
									<p>Through our long partnership with the National Merit Scholarship Corporation, CACI provides college scholarships to National Merit Scholarship Program winners pursuing degrees in STEM-related majors.</p>
									</div>
								</div>
								<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft text-center'>
										<img alt='FIRST (For Inspiration and Recognition of Science and Technology) logo.' src={firstLogo} className='socialCompanyLogo' />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>FIRST (For Inspiration and Recognition of Science and Technology)</h4>
									<p>CACI supports student participation in STEM through robotic team-building competitions at local K-12 schools. CACI employees serve as team mentors and volunteers, encouraging students to pursue STEM education.</p>
									</div>
								</div>
								<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft text-center'>
										<img alt='Navy League of the United States STEM Expo logo.' src={navyStemLogo} className='socialCompanyLogo' />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>Navy League of the United States STEM Expo</h4>
									<p>This event empowers 5th- to 12th-grade students interested in STEM careers. Students and parents are invited to enjoy interactive workshops, demonstrations, STEM career information, networking opportunities, and more.</p>
									</div>
								</div>
							</Col>
							<Col lg={6}>
								<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft text-center'>
										<img alt='Northern Virginia Science Center logo.' src={nvscLogo} className='socialCompanyLogo' style={{width: '100%'}} />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>Northern Virginia Science Center</h4>
									<p>CACI is a proud title sponsor of the Northern Virginia Science Center and sponsor of the “Human” gallery. The center is scheduled to open in late 2027 and will be a world-class, interactive museum for families, students, and learners of all ages that sparks curiosity and supports discovery, innovation, and fun.</p>
									</div>
								</div>
								<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft text-center'>
										<img alt='Scouting America logo.' src={scoutingAmericaLogo} className='socialCompanyLogo' />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>Scouting America</h4>
									<p>Scouting America National Capital Area Council’s (NCAC) annual Technology Good Scout Award event celebrates leaders in the technology industry while supporting Scouting America’s mission to prepare young people for the future. Proceeds from this event assist with NCAC’s STEM initiatives, providing Scouts with hands-on learning experiences that foster innovation, critical thinking, and problem-solving skills. These funds ensure Scouts have access to cutting-edge opportunities in science, technology, engineering, and mathematics.</p>
									</div>
								</div>
								<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft text-center'>
										<img alt='George Mason University logo.' src={gmuLogo} className='socialCompanyLogo' />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>George Mason University</h4>
									<p>Through our support of GMU’s Early Identification Program, we provide mentorship, scholarships, internships, and academic resources to a cohort of first-generation college students.</p>
									<p>Annually, we sponsor and collaborate with GMU’s Office of Outreach, Student Success, and Engagement within the College of Engineering and Computing to host BLAST Off Week (Belonging, Leadership, Access, Success, and Trailblazing), curated to enhance students’ workforce development and experiential learning.</p>
									</div>
								</div>
							</Col>
						</Row>
					</Col>
				</Row>
				<br/>
				<Row className='gx-5 mt-5'>
					<Col>
							<Row>
							<Col>
							<p className='callOutParagraph' data-aos='zoom-in' data-aos-duration='750' data-aos-once='true'>We proudly support military <span style={{fontWeight: '300'}}>service members, veterans, and their families to demonstrate our respect and honor their sacrifices.</span></p>
							</Col>
							</Row>
						<Row className='gx-5 my-5'>
							<Col lg={6}>
								<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft text-center'>
										<img alt='Cause logo.' src={causeLogo} className='socialCompanyLogo' />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>Blue Star Families</h4>
									<p>Blue Star Families empowers families to thrive as they serve. They are committed to strengthening military families by connecting them with their neighbors to create vibrant communities of mutual support.</p>
									</div>
								</div>
								<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft text-center'>
										<img alt='Spookstock Foundation logo.' src={spookstockLogo} className='socialCompanyLogo' />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>Spookstock Foundation</h4>
									<p>The Spookstock Foundation works to seek the flourishing of our nation’s shadow warriors and their families.</p>
									</div>
								</div>
								<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft text-center'>
										<img alt='TAPS - Tragedy Assistance Program for Survivors logo.' src={tapsLogo} className='socialCompanyLogo' />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>TAPS - Tragedy Assistance Program for Survivors</h4>
									<p>TAPS provides compassionate care and comprehensive resources for all those grieving the death of a military or veteran loved one.</p>
									</div>
								</div>
								<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft'>
										<img alt='Fisher House Foundation logo.' src={fisherHouseLogo} className='socialCompanyLogo' />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>Fisher House Foundation</h4>
									<p>Fisher House Foundation builds comfort homes where military and veteran families can stay free of charge, while a loved one is in the hospital. Their homes are located at military and Veteran Affairs medical centers around the world.</p>
									</div>
								</div>
							</Col>
							<Col lg={6}>
								<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft'>
										<img alt='The Honor Foundation logo.' src={honorFoundationLogo} className='socialCompanyLogo' />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>The Honor Foundation</h4>
									<p>The Honor Foundation is a career transition program for U.S. Special Operations Forces that effectively translates their military service to the private sector and helps create the next generation of corporate and community leaders. Through their professional development programs and ecosystem of support and technology, every step is dedicated to preparing these outstanding men and women to continue to maximize their potential during and after their service career.</p>
									</div>
								</div>
								<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft'>
										<img alt='Our Military Kids logo.' src={omkLogo} className='socialCompanyLogo' />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>Our Military Kids</h4>
									<p>Our Military Kids provides extracurricular activity grants to children and teens of deployed National Guard, deployed Reserve, or post-9/11 combat-wounded, ill, or injured veterans in treatment. Our Military Kids activity grants build the children's self-confidence, enhance family wellness, and strengthen a shared sense of community.</p>
									</div>
								</div>
																<div className='stat'>
									<div data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='statFloatLeft'>
										<img alt='Wreaths Across America logo.' src={wreathsAcrossAmericaLogo} className='socialCompanyLogo' />
									</div>
									<div data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='statFloatRight ps-3'>
									<h4>Wreaths Across America</h4>
									<p>Our servicemen and women sacrifice their time and safety every single day of the year to preserve our freedoms. That is why the Wreaths Across America mission to Remember, Honor and Teach lasts all year long in a number of ways to show our veterans and their families that we will not forget—we will never forget.</p>
									</div>
								</div>
							</Col>
						</Row>
					</Col>
				</Row>
				<br/>
				<Row className='gx-5'>
					<Col>
						<Row className='gx-5'>
							<Col lg={6}>
							<p className='callOutParagraph' data-aos='zoom-in' data-aos-duration='750' data-aos-once='true'>We offer our dedicated employees a comprehensive set of physical and mental well-being programs and rewards.</p>
						<h2 className='mt-5 mb-4 section' id='section3'>Employee well-being</h2>
								<p>We offer our dedicated employees a comprehensive set of physical and mental well-being programs.</p>
								<p>We equip employees with knowledge and support to help them thrive at work and in life, with offerings like wellness incentives, chronic health management programs, weight management tools, and financial planning resources.</p>
								<p>We also offer strong benefits that encourage an active and balanced lifestyle. This offering includes our Employee Assistance Program, which gives all employees and their families immediate, confidential help for any work, health, or life concern at any time, free of charge. For employees who are growing their family, we offer adoption assistance, parental leave, and access to fertility and family-bonding support.</p>

						<h3 className='mt-5 mb-4'>Employee engagement</h3>
							<p>We support employee engagement by encouraging employees to form strong connections at work through:</p>
							<ul>
								<li>Communities of Practice</li>
								<li>Mentoring program</li>
								<li>Networking opportunities</li>
								<li>Communities of Engagement</li>
							</ul>
							<h3 className='mt-5 mb-4'>Communities of Practice</h3>
							<p>CACI’s Communities of Practice meet regularly to share knowledge, learn about new technologies, and network with others with shared interests across the company. CACI also offers online courses for certification training and reimburses the costs of exams for certifications sponsored by Communities of Practice.</p>
							<h3 className='mt-5 mb-4'>Networking opportunities</h3>
							<p>Flexible learning and networking opportunities are core to CACI’s training and development initiatives. We encourage our employees to take time to connect with others in their fields — both inside and outside of CACI — to gain new expertise and develop their career paths.</p>
							<h3 className='mt-5 mb-4'>Communities of Engagement</h3>
							<p>CACI offers five Communities of Engagement (CoE) groups: Learning Exchange, Military & Veterans Partnerships, Outreach Impact, Wellness & Accessibility, and Workplace Connections.</p>
							<p>CACI’s CoEs are spaces for all employees to come together based on shared interests to collaborate, engage with each other and our community, and promote personal and professional growth. Through these shared commitments, we create an environment where employees feel valued, connected, and engaged, with opportunities for meaningful growth.</p>
							</Col>
							<Col lg={6}>
								<img alt='Two interns in an office setting.' data-aos='fade-left' data-aos-duration='750' data-aos-once='true' src={employeeWellBeingImage} style={{width: '100%'}} />
							</Col>
						</Row>
					</Col>
				</Row>
				<br/>
				<Row className='gx-5'>
					<h2 className='mt-5 mb-4 section' id='section4'>Workplace safety</h2>
				</Row>
				<Row className='gx-5'>
					<Col lg={6}>
						<p>Success at CACI begins and ends with the safety of our employees, customers, visitors, and contractors. Our goal is for everyone to return home to their families safely each day. This begins with our corporate safety policies, which guide us as we work to eliminate injuries in our workplace.</p>
						<p>Within our safety program, employees must:</p>
						<ul>
							<li>Identify and mitigate hazards</li>
							<li>Prevent unsafe acts and conditions</li>
							<li>Stop work immediately if there is a risk to life or health</li>
							<li>Communicate on health and safety issues to employee managers</li>
						</ul>
						<p>In addition, employee leaders thoroughly investigate serious incidents to identify root causes. Insight from these analyses inform program improvements, communications, and safety training, reducing injuries and encouraging proactive reporting.</p>
					</Col>
					<Col lg={6}>
						<div className='table-container' data-aos='fade-up' data-aos-duration='750' data-aos-once='true'>
							<Table className='mt-5'>
								<thead>
									<tr style={{borderBottom: '4px solid #000', fontWeight: '600', color: '#000'}}>
										<td>Employees*</td>
										<td>CY 2021</td>
										<td>CY 2022</td>
										<td>CY 2023</td>
										<td>CY 2024</td>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td style={{borderBottom: '1px solid grey'}}>Number of high-consequence work-related injuries</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>9</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>3</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>13</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>17</td>
									</tr>
									<tr>
										<td style={{borderBottom: '1px solid grey'}}>Rate of high-consequence work-related injuries</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>0.04</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>0.02</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>0.07</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>0.09</td>
									</tr>
									<tr>
										<td style={{borderBottom: '1px solid grey'}}>Number of recordable work-related injuries</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>42</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>21</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>22</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>36</td>
									</tr>
									<tr>
										<td style={{borderBottom: '1px solid grey'}}>Rate of recordable work-related injuries</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>0.2</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>0.12</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>0.12</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>0.19</td>
									</tr>
									<tr>
										<td style={{borderBottom: '1px solid grey'}}>Number of hours worked</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>37,647,061</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>36,116,920</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>37,985,472</td>
										<td className='text-center' style={{borderBottom: '1px solid grey'}}>38,779,767</td>
									</tr>
									<tr>
										<td colSpan='3' style={{fontSize: '0.75rem', borderBottom: '0px', fontWeight: '300'}}>*Numbers represent U.S.-based employees</td>
									</tr>
								</tbody>
							</Table>
						</div>
					</Col>
				</Row>
				<br/>
				<Row className='gx-5'>
						<Col lg={6}>
							<h2 className='mt-5 mb-4 section' id='section5'>Employee training and development</h2>
						  <p>Our learning mantra is connect, learn, and achieve. Our people, their skills, and their knowledge are the key to our success, so we actively invest in our employees’ continuous development.</p>
						  <p>We use a variety of recruiting and outreach strategies to build and maintain the strongest talent pool possible. Our employees combine their own experiences and perspectives with our network of resources to tackle challenges creatively and drive consistent, enterprise-wide growth. We’re focused on creating a culture where our people can thrive.</p>
							<h3 className='mt-5 mb-4'>Early career</h3>
							<p>We provide CACI interns and entry-level professionals with mentorship, flexibility, and educational opportunities that strengthen our collective success. Every new employee, their manager, and their team are equipped with effective and thoughtfully curated resources to ensure a seamless first year.</p>
							<h3 className='mt-5 mb-4'>Great First Year</h3>
							<p>The Great First Year initiative offers every new employee, manager, and executive a comprehensive set of impactful and timely activities like training sessions, meaningful conversations, and team-building activities. These facilitate a smooth integration into their respective roles, their teams, and CACI’s organizational culture as a whole. New leaders are presented with meticulously crafted transition plans, which include the provision of peer sponsors, dedicated integration sessions with their new teams, and personalized transition coaching, all tailored to provide robust support during the pivotal first three months on the job.</p>
						</Col>
						<Col className='text-center' lg={6}>
							<Row className='gx-5 mt-5'>
								<Col lg={6}>
									<div style={{height: 'auto'}} data-aos='fade-right' data-aos-duration='750' data-aos-once='true'>
										<CustomCircularProgress size={175} progressColor="#5F687A" trackColor="rgba(95, 104, 122, 0.5)" targetValue={87.4} figureText='<span data-aos="zoom-in" data-aos-duration="500" data-aos-once="true" data-aos-delay="750">Percentage of new hires <br/> who found their Day One<br/> experience to be</span> <span data-aos="zoom-in" data-aos-duration="750" data-aos-once="true" style="font-weight: 600;">helpful </span> <span data-aos="zoom-in" data-aos-duration="500" data-aos-once="true" data-aos-delay="750"><br/>and</span> <span data-aos="zoom-in" data-aos-duration="750" data-aos-once="true"  style="font-weight: 600;">informative.</span></div>' />
									</div>
									<div style={{height: 'auto'}} data-aos='fade-right' data-aos-duration='750' data-aos-once='true' className='mt-5'>
										<CustomCircularProgress size={175} progressColor="#5F687A" trackColor="rgba(95, 104, 122, 0.5)" targetValue={87.7} figureText='<span data-aos="zoom-in" data-aos-duration="750" data-aos-once="true" data-aos-delay="750">Percentage of new hires<br/>who believe CACI will offer<br/> long-term</span> <span data-aos="zoom-in" data-aos-duration="750" data-aos-once="true" style="font-weight: 600;">growth</span> <span data-aos="zoom-in" data-aos-duration="500" data-aos-once="true" data-aos-delay="750">and <br/>career</span> <span data-aos="zoom-in" data-aos-duration="750" data-aos-once="true" style="font-weight: 600;">opportunities.</span></div>' />
									</div>
								</Col>
								<Col lg={6}>
									<div style={{height: 'auto'}} data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='mt-5 mt-lg-0'>
										<CustomCircularProgress size={175} progressColor="#5F687A" trackColor="rgba(95, 104, 122, 0.5)" targetValue={81.6} figureText='<span data-aos="zoom-in" data-aos-duration="750" data-aos-once="true" data-aos-delay="500">Percentage of new hires<br/>who found their onboarding <br/>process</span> <span data-aos="zoom-in" data-aos-duration="750" data-aos-once="true" style="font-weight: 600;">interesting<br/></span> <span data-aos="zoom-in" data-aos-duration="750" data-aos-once="true" data-aos-delay="500">and</span> <span data-aos="zoom-in" data-aos-duration="750" data-aos-once="true" style="font-weight: 600;">interactive.</span></div>' />
									</div>
									<div style={{height: 'auto'}} data-aos='fade-left' data-aos-duration='750' data-aos-once='true' className='mt-5'>
										<CustomCircularProgress size={175} progressColor="#5F687A" trackColor="rgba(95, 104, 122, 0.5)" targetValue={86.1} figureText='<span data-aos="zoom-in" data-aos-duration="750" data-aos-once="true" data-aos-delay="500">Percentage of new hires <br/>who feel</span> <span data-aos="zoom-in" data-aos-duration="750" data-aos-once="true" style="font-weight: 600;">positively<br/> challenged.</span> <span data-aos="zoom-in" data-aos-duration="750" data-aos-once="true" data-aos-delay="500">and</span> <span data-aos="zoom-in" data-aos-duration="750" data-aos-once="true" style="font-weight: 600;">engaged.</span></div>' />
									</div>
								</Col>
							</Row>
						</Col>
				</Row>
				<br/>
				<Row className='gx-5'>
					<Col lg={6}>
						<h3 className='mt-5 mb-4'>Training</h3>
						<p>We encourage all employees to earn certifications, upskill, and reskill using our industry-leading resources. We invest in a wide range of activities including training, on-the-job opportunities, and supportive managers who serve as coaches to elevate the employee experience and bridge the gap between jobs and skills. Our career development tools include:</p>
						<ul>
							<li>CACI Virtual University</li>
							<li>LinkedIn Learning</li>
							<li>Skillsoft Percipio</li>
							<li>CACI Communities of Practice (CoP)</li>
							<li>CACI learning academies</li>
							<li>Project management academies</li>
							<li>Tuition reimbursement programs</li>
							<li>Discounted tuition rates</li>
						</ul>
						<h3 className='mt-5 mb-4'>Leadership Development Programs</h3>
						<p>Leadership is both a privilege and a responsibility. We invest boldly in comprehensive leadership development that strengthens leadership capability today while building sustainable readiness for tomorrow. Through Elevate@CACI, we prepare high-potential and emerging leaders for future roles, strengthening succession and long-term leadership continuity.</p>
						<p>Lead@CACI supports leaders at every level with scalable, role-relevant development aligned to our mission and talent strategy. To support early success, Great First Year for Managers provides newly hired and newly promoted leaders with practical, flexible learning on CACI’s tools, processes, and ways of working so they can contribute with confidence from day one.</p>
					</Col>
					<Col lg={6}>
						<img alt='Two CACI employees.' data-aos='fade-left' data-aos-duration='750' data-aos-once='true' src={trainingImage} style={{width: '100%'}} />
					</Col>
				</Row>
				<br/>
				<Row className='gx-5 pb-5'>
					<Col lg={6}>
						<h3 className='mt-5 mb-4'>Fellows Program</h3>
						<p>Reflecting our growth in the high-tech and expanding tech R&D portfolio, this annual program honors a cohort of our outstanding technical talent — roughly 1 in 1,000 of our total population.</p>
						<h3 className='mt-5 mb-4'>Champions Program</h3>
						<p>CACI Champions recognizes outstanding employees and teams for excellence in leadership, technical innovation, performance, customer focus, and winning and growing the business.</p>
						<h3 className='mt-5 mb-4'>Career mobility – CACI <em>#makingmoves</em></h3>
						<p>Our <em>#makingmoves</em> initiative empowers our entire workforce to continue learning and growing through tools such as:</p>
						<ul>
							<li>Career dashboards</li>
							<li>Dedicated mobility team</li>
							<li>Career-centric campaigns</li>
							<li>Supportive culture and policies</li>
							<li>Career development webinars</li>
							<li>Career assessment tools</li>
						</ul>
						<p>The <em>#makingmoves</em> internal mobility program promotes employees owning their career development and creates a scalable, resilient workforce. The CACI Career Hub connects our employees with opportunities across the company that match their skills and interests, contributing to our rising internal mobility rate over time.</p>
						<h3 className='mt-5 mb-4'>Career development</h3>
						<p>CACI offers career development workshops and webinars that help employees take an active role in their growth and career progression. These sessions increase awareness of available development programs and learning opportunities, while providing practical guidance on skill development and internal mobility, supporting long-term capability growth, internal movement, and employee engagement.</p>
						<Row className='mt-5 pb-5'>
							<Col xs={6} data-aos='fade-up' data-aos-duration='750' data-aos-once='true'>
										<span className="infographicHeading"><CounterAnimation targetNumber={26.6} />%</span>
										<br/>
										<span className='infographicSubHeading'>Openings filled by<br/> internal candidates.</span>
							</Col>
							<Col xs={6} data-aos='fade-up' data-aos-duration='750' data-aos-once='true'>
										<span className="infographicHeading"><CounterAnimation targetNumber={42.3} />%</span>
										<br/>
										<span className='infographicSubHeading'>Increase since FY 2019.</span>
							</Col>
						</Row>
					</Col>
					<Col lg={6}>
						<img alt='A CACI employee.' data-aos='fade-left' data-aos-duration='750' data-aos-once='true' src={careerMobilityImage} style={{width: '100%'}} />
					</Col>
				</Row>
			</div>
		<div style={{ clear: 'both' }}></div>
		</Container>
		          <div className='navigationArrows'>
        <div ref={leftArrowRef} className='arrowContainer leftArrow' 
onTouchStart={() => {
                    leftArrowRef.current.classList.add('arrowTouchActive');
                }}
            onTouchEnd={() => {
                    leftArrowRef.current.classList.remove('arrowTouchActive');
                }} onClick={() => {
              navigate('/environment');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});

               for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[5].classList.add('active');
              document.getElementsByClassName('underline')[5].classList.add('active');
            }}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </div>
        <div ref={rightArrowRef} className='arrowContainer rightArrow'
        onTouchStart={() => {
                    rightArrowRef.current.classList.add('arrowTouchActive');
                }}
            onTouchEnd={() => {
                    rightArrowRef.current.classList.remove('arrowTouchActive');
                }} onClick={() => {
              navigate('/governance');
              window.scrollTo({ top:-300, left:0, behavior: "instant"});
              for (let i = 0; i < 8; i++)
              {
                    document.getElementsByClassName('navBar-link-inner')[i].classList.remove('active');
                    document.getElementsByClassName('underline')[i].classList.remove('active');
              }
              document.getElementsByClassName('navBar-link-inner')[7].classList.add('active');
              document.getElementsByClassName('underline')[7].classList.add('active');
            }}>
          <FontAwesomeIcon icon={faArrowRight} />
        </div>
      </div>
		</>
	);
}